webpackJsonp([114276838955818,60335399758886],{

/***/ 122:
/***/ (function(module, exports) {

	module.exports = {"layoutContext":{}}

/***/ }),

/***/ 218:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _index = __webpack_require__(224);
	
	var _index2 = _interopRequireDefault(_index);
	
	var _layoutIndex = __webpack_require__(122);
	
	var _layoutIndex2 = _interopRequireDefault(_layoutIndex);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = function (props) {
	  return _react2.default.createElement(_index2.default, _extends({}, props, _layoutIndex2.default));
	};
	
	module.exports = exports["default"];

/***/ }),

/***/ 309:
/***/ (function(module, exports, __webpack_require__) {

	var pSlice = Array.prototype.slice;
	var objectKeys = __webpack_require__(311);
	var isArguments = __webpack_require__(310);
	
	var deepEqual = module.exports = function (actual, expected, opts) {
	  if (!opts) opts = {};
	  // 7.1. All identical values are equivalent, as determined by ===.
	  if (actual === expected) {
	    return true;
	
	  } else if (actual instanceof Date && expected instanceof Date) {
	    return actual.getTime() === expected.getTime();
	
	  // 7.3. Other pairs that do not both pass typeof value == 'object',
	  // equivalence is determined by ==.
	  } else if (!actual || !expected || typeof actual != 'object' && typeof expected != 'object') {
	    return opts.strict ? actual === expected : actual == expected;
	
	  // 7.4. For all other Object pairs, including Array objects, equivalence is
	  // determined by having the same number of owned properties (as verified
	  // with Object.prototype.hasOwnProperty.call), the same set of keys
	  // (although not necessarily the same order), equivalent values for every
	  // corresponding key, and an identical 'prototype' property. Note: this
	  // accounts for both named and indexed properties on Arrays.
	  } else {
	    return objEquiv(actual, expected, opts);
	  }
	}
	
	function isUndefinedOrNull(value) {
	  return value === null || value === undefined;
	}
	
	function isBuffer (x) {
	  if (!x || typeof x !== 'object' || typeof x.length !== 'number') return false;
	  if (typeof x.copy !== 'function' || typeof x.slice !== 'function') {
	    return false;
	  }
	  if (x.length > 0 && typeof x[0] !== 'number') return false;
	  return true;
	}
	
	function objEquiv(a, b, opts) {
	  var i, key;
	  if (isUndefinedOrNull(a) || isUndefinedOrNull(b))
	    return false;
	  // an identical 'prototype' property.
	  if (a.prototype !== b.prototype) return false;
	  //~~~I've managed to break Object.keys through screwy arguments passing.
	  //   Converting to array solves the problem.
	  if (isArguments(a)) {
	    if (!isArguments(b)) {
	      return false;
	    }
	    a = pSlice.call(a);
	    b = pSlice.call(b);
	    return deepEqual(a, b, opts);
	  }
	  if (isBuffer(a)) {
	    if (!isBuffer(b)) {
	      return false;
	    }
	    if (a.length !== b.length) return false;
	    for (i = 0; i < a.length; i++) {
	      if (a[i] !== b[i]) return false;
	    }
	    return true;
	  }
	  try {
	    var ka = objectKeys(a),
	        kb = objectKeys(b);
	  } catch (e) {//happens when one is a string literal and the other isn't
	    return false;
	  }
	  // having the same number of owned properties (keys incorporates
	  // hasOwnProperty)
	  if (ka.length != kb.length)
	    return false;
	  //the same set of keys (although not necessarily the same order),
	  ka.sort();
	  kb.sort();
	  //~~~cheap key test
	  for (i = ka.length - 1; i >= 0; i--) {
	    if (ka[i] != kb[i])
	      return false;
	  }
	  //equivalent values for every corresponding key, and
	  //~~~possibly expensive deep test
	  for (i = ka.length - 1; i >= 0; i--) {
	    key = ka[i];
	    if (!deepEqual(a[key], b[key], opts)) return false;
	  }
	  return typeof a === typeof b;
	}


/***/ }),

/***/ 310:
/***/ (function(module, exports) {

	var supportsArgumentsClass = (function(){
	  return Object.prototype.toString.call(arguments)
	})() == '[object Arguments]';
	
	exports = module.exports = supportsArgumentsClass ? supported : unsupported;
	
	exports.supported = supported;
	function supported(object) {
	  return Object.prototype.toString.call(object) == '[object Arguments]';
	};
	
	exports.unsupported = unsupported;
	function unsupported(object){
	  return object &&
	    typeof object == 'object' &&
	    typeof object.length == 'number' &&
	    Object.prototype.hasOwnProperty.call(object, 'callee') &&
	    !Object.prototype.propertyIsEnumerable.call(object, 'callee') ||
	    false;
	};


/***/ }),

/***/ 311:
/***/ (function(module, exports) {

	exports = module.exports = typeof Object.keys === 'function'
	  ? Object.keys : shim;
	
	exports.shim = shim;
	function shim (obj) {
	  var keys = [];
	  for (var key in obj) keys.push(key);
	  return keys;
	}


/***/ }),

/***/ 318:
/***/ (function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_RESULT__;/*!
	  Copyright (c) 2015 Jed Watson.
	  Based on code that is Copyright 2013-2015, Facebook, Inc.
	  All rights reserved.
	*/
	/* global define */
	
	(function () {
		'use strict';
	
		var canUseDOM = !!(
			typeof window !== 'undefined' &&
			window.document &&
			window.document.createElement
		);
	
		var ExecutionEnvironment = {
	
			canUseDOM: canUseDOM,
	
			canUseWorkers: typeof Worker !== 'undefined',
	
			canUseEventListeners:
				canUseDOM && !!(window.addEventListener || window.attachEvent),
	
			canUseViewport: canUseDOM && !!window.screen
	
		};
	
		if (true) {
			!(__WEBPACK_AMD_DEFINE_RESULT__ = function () {
				return ExecutionEnvironment;
			}.call(exports, __webpack_require__, exports, module), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
		} else if (typeof module !== 'undefined' && module.exports) {
			module.exports = ExecutionEnvironment;
		} else {
			window.ExecutionEnvironment = ExecutionEnvironment;
		}
	
	}());


/***/ }),

/***/ 429:
/***/ (function(module, exports, __webpack_require__) {

	exports.__esModule = true;
	exports.Helmet = undefined;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(6);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactSideEffect = __webpack_require__(448);
	
	var _reactSideEffect2 = _interopRequireDefault(_reactSideEffect);
	
	var _deepEqual = __webpack_require__(309);
	
	var _deepEqual2 = _interopRequireDefault(_deepEqual);
	
	var _HelmetUtils = __webpack_require__(430);
	
	var _HelmetConstants = __webpack_require__(202);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var Helmet = function Helmet(Component) {
	    var _class, _temp;
	
	    return _temp = _class = function (_React$Component) {
	        _inherits(HelmetWrapper, _React$Component);
	
	        function HelmetWrapper() {
	            _classCallCheck(this, HelmetWrapper);
	
	            return _possibleConstructorReturn(this, _React$Component.apply(this, arguments));
	        }
	
	        HelmetWrapper.prototype.shouldComponentUpdate = function shouldComponentUpdate(nextProps) {
	            return !(0, _deepEqual2.default)(this.props, nextProps);
	        };
	
	        HelmetWrapper.prototype.mapNestedChildrenToProps = function mapNestedChildrenToProps(child, nestedChildren) {
	            if (!nestedChildren) {
	                return null;
	            }
	
	            switch (child.type) {
	                case _HelmetConstants.TAG_NAMES.SCRIPT:
	                case _HelmetConstants.TAG_NAMES.NOSCRIPT:
	                    return {
	                        innerHTML: nestedChildren
	                    };
	
	                case _HelmetConstants.TAG_NAMES.STYLE:
	                    return {
	                        cssText: nestedChildren
	                    };
	            }
	
	            throw new Error("<" + child.type + " /> elements are self-closing and can not contain children. Refer to our API for more information.");
	        };
	
	        HelmetWrapper.prototype.flattenArrayTypeChildren = function flattenArrayTypeChildren(_ref) {
	            var _extends2;
	
	            var child = _ref.child,
	                arrayTypeChildren = _ref.arrayTypeChildren,
	                newChildProps = _ref.newChildProps,
	                nestedChildren = _ref.nestedChildren;
	
	            return _extends({}, arrayTypeChildren, (_extends2 = {}, _extends2[child.type] = [].concat(arrayTypeChildren[child.type] || [], [_extends({}, newChildProps, this.mapNestedChildrenToProps(child, nestedChildren))]), _extends2));
	        };
	
	        HelmetWrapper.prototype.mapObjectTypeChildren = function mapObjectTypeChildren(_ref2) {
	            var _extends3, _extends4;
	
	            var child = _ref2.child,
	                newProps = _ref2.newProps,
	                newChildProps = _ref2.newChildProps,
	                nestedChildren = _ref2.nestedChildren;
	
	            switch (child.type) {
	                case _HelmetConstants.TAG_NAMES.TITLE:
	                    return _extends({}, newProps, (_extends3 = {}, _extends3[child.type] = nestedChildren, _extends3.titleAttributes = _extends({}, newChildProps), _extends3));
	
	                case _HelmetConstants.TAG_NAMES.BODY:
	                    return _extends({}, newProps, {
	                        bodyAttributes: _extends({}, newChildProps)
	                    });
	
	                case _HelmetConstants.TAG_NAMES.HTML:
	                    return _extends({}, newProps, {
	                        htmlAttributes: _extends({}, newChildProps)
	                    });
	            }
	
	            return _extends({}, newProps, (_extends4 = {}, _extends4[child.type] = _extends({}, newChildProps), _extends4));
	        };
	
	        HelmetWrapper.prototype.mapArrayTypeChildrenToProps = function mapArrayTypeChildrenToProps(arrayTypeChildren, newProps) {
	            var newFlattenedProps = _extends({}, newProps);
	
	            Object.keys(arrayTypeChildren).forEach(function (arrayChildName) {
	                var _extends5;
	
	                newFlattenedProps = _extends({}, newFlattenedProps, (_extends5 = {}, _extends5[arrayChildName] = arrayTypeChildren[arrayChildName], _extends5));
	            });
	
	            return newFlattenedProps;
	        };
	
	        HelmetWrapper.prototype.warnOnInvalidChildren = function warnOnInvalidChildren(child, nestedChildren) {
	            if (false) {
	                if (!_HelmetConstants.VALID_TAG_NAMES.some(function (name) {
	                    return child.type === name;
	                })) {
	                    if (typeof child.type === "function") {
	                        return (0, _HelmetUtils.warn)("You may be attempting to nest <Helmet> components within each other, which is not allowed. Refer to our API for more information.");
	                    }
	
	                    return (0, _HelmetUtils.warn)("Only elements types " + _HelmetConstants.VALID_TAG_NAMES.join(", ") + " are allowed. Helmet does not support rendering <" + child.type + "> elements. Refer to our API for more information.");
	                }
	
	                if (nestedChildren && typeof nestedChildren !== "string" && (!Array.isArray(nestedChildren) || nestedChildren.some(function (nestedChild) {
	                    return typeof nestedChild !== "string";
	                }))) {
	                    throw new Error("Helmet expects a string as a child of <" + child.type + ">. Did you forget to wrap your children in braces? ( <" + child.type + ">{``}</" + child.type + "> ) Refer to our API for more information.");
	                }
	            }
	
	            return true;
	        };
	
	        HelmetWrapper.prototype.mapChildrenToProps = function mapChildrenToProps(children, newProps) {
	            var _this2 = this;
	
	            var arrayTypeChildren = {};
	
	            _react2.default.Children.forEach(children, function (child) {
	                if (!child || !child.props) {
	                    return;
	                }
	
	                var _child$props = child.props,
	                    nestedChildren = _child$props.children,
	                    childProps = _objectWithoutProperties(_child$props, ["children"]);
	
	                var newChildProps = (0, _HelmetUtils.convertReactPropstoHtmlAttributes)(childProps);
	
	                _this2.warnOnInvalidChildren(child, nestedChildren);
	
	                switch (child.type) {
	                    case _HelmetConstants.TAG_NAMES.LINK:
	                    case _HelmetConstants.TAG_NAMES.META:
	                    case _HelmetConstants.TAG_NAMES.NOSCRIPT:
	                    case _HelmetConstants.TAG_NAMES.SCRIPT:
	                    case _HelmetConstants.TAG_NAMES.STYLE:
	                        arrayTypeChildren = _this2.flattenArrayTypeChildren({
	                            child: child,
	                            arrayTypeChildren: arrayTypeChildren,
	                            newChildProps: newChildProps,
	                            nestedChildren: nestedChildren
	                        });
	                        break;
	
	                    default:
	                        newProps = _this2.mapObjectTypeChildren({
	                            child: child,
	                            newProps: newProps,
	                            newChildProps: newChildProps,
	                            nestedChildren: nestedChildren
	                        });
	                        break;
	                }
	            });
	
	            newProps = this.mapArrayTypeChildrenToProps(arrayTypeChildren, newProps);
	            return newProps;
	        };
	
	        HelmetWrapper.prototype.render = function render() {
	            var _props = this.props,
	                children = _props.children,
	                props = _objectWithoutProperties(_props, ["children"]);
	
	            var newProps = _extends({}, props);
	
	            if (children) {
	                newProps = this.mapChildrenToProps(children, newProps);
	            }
	
	            return _react2.default.createElement(Component, newProps);
	        };
	
	        _createClass(HelmetWrapper, null, [{
	            key: "canUseDOM",
	
	
	            // Component.peek comes from react-side-effect:
	            // For testing, you may use a static peek() method available on the returned component.
	            // It lets you get the current state without resetting the mounted instance stack.
	            // Don’t use it for anything other than testing.
	
	            /**
	            * @param {Object} base: {"target": "_blank", "href": "http://mysite.com/"}
	            * @param {Object} bodyAttributes: {"className": "root"}
	            * @param {String} defaultTitle: "Default Title"
	            * @param {Boolean} defer: true
	            * @param {Boolean} encodeSpecialCharacters: true
	            * @param {Object} htmlAttributes: {"lang": "en", "amp": undefined}
	            * @param {Array} link: [{"rel": "canonical", "href": "http://mysite.com/example"}]
	            * @param {Array} meta: [{"name": "description", "content": "Test description"}]
	            * @param {Array} noscript: [{"innerHTML": "<img src='http://mysite.com/js/test.js'"}]
	            * @param {Function} onChangeClientState: "(newState) => console.log(newState)"
	            * @param {Array} script: [{"type": "text/javascript", "src": "http://mysite.com/js/test.js"}]
	            * @param {Array} style: [{"type": "text/css", "cssText": "div { display: block; color: blue; }"}]
	            * @param {String} title: "Title"
	            * @param {Object} titleAttributes: {"itemprop": "name"}
	            * @param {String} titleTemplate: "MySite.com - %s"
	            */
	            set: function set(canUseDOM) {
	                Component.canUseDOM = canUseDOM;
	            }
	        }]);
	
	        return HelmetWrapper;
	    }(_react2.default.Component), _class.propTypes = {
	        base: _propTypes2.default.object,
	        bodyAttributes: _propTypes2.default.object,
	        children: _propTypes2.default.oneOfType([_propTypes2.default.arrayOf(_propTypes2.default.node), _propTypes2.default.node]),
	        defaultTitle: _propTypes2.default.string,
	        defer: _propTypes2.default.bool,
	        encodeSpecialCharacters: _propTypes2.default.bool,
	        htmlAttributes: _propTypes2.default.object,
	        link: _propTypes2.default.arrayOf(_propTypes2.default.object),
	        meta: _propTypes2.default.arrayOf(_propTypes2.default.object),
	        noscript: _propTypes2.default.arrayOf(_propTypes2.default.object),
	        onChangeClientState: _propTypes2.default.func,
	        script: _propTypes2.default.arrayOf(_propTypes2.default.object),
	        style: _propTypes2.default.arrayOf(_propTypes2.default.object),
	        title: _propTypes2.default.string,
	        titleAttributes: _propTypes2.default.object,
	        titleTemplate: _propTypes2.default.string
	    }, _class.defaultProps = {
	        defer: true,
	        encodeSpecialCharacters: true
	    }, _class.peek = Component.peek, _class.rewind = function () {
	        var mappedState = Component.rewind();
	        if (!mappedState) {
	            // provide fallback if mappedState is undefined
	            mappedState = (0, _HelmetUtils.mapStateOnServer)({
	                baseTag: [],
	                bodyAttributes: {},
	                encodeSpecialCharacters: true,
	                htmlAttributes: {},
	                linkTags: [],
	                metaTags: [],
	                noscriptTags: [],
	                scriptTags: [],
	                styleTags: [],
	                title: "",
	                titleAttributes: {}
	            });
	        }
	
	        return mappedState;
	    }, _temp;
	};
	
	var NullComponent = function NullComponent() {
	    return null;
	};
	
	var HelmetSideEffects = (0, _reactSideEffect2.default)(_HelmetUtils.reducePropsToState, _HelmetUtils.handleClientStateChange, _HelmetUtils.mapStateOnServer)(NullComponent);
	
	var HelmetExport = Helmet(HelmetSideEffects);
	HelmetExport.renderStatic = HelmetExport.rewind;
	
	exports.Helmet = HelmetExport;
	exports.default = HelmetExport;

/***/ }),

/***/ 202:
/***/ (function(module, exports) {

	exports.__esModule = true;
	var ATTRIBUTE_NAMES = exports.ATTRIBUTE_NAMES = {
	    BODY: "bodyAttributes",
	    HTML: "htmlAttributes",
	    TITLE: "titleAttributes"
	};
	
	var TAG_NAMES = exports.TAG_NAMES = {
	    BASE: "base",
	    BODY: "body",
	    HEAD: "head",
	    HTML: "html",
	    LINK: "link",
	    META: "meta",
	    NOSCRIPT: "noscript",
	    SCRIPT: "script",
	    STYLE: "style",
	    TITLE: "title"
	};
	
	var VALID_TAG_NAMES = exports.VALID_TAG_NAMES = Object.keys(TAG_NAMES).map(function (name) {
	    return TAG_NAMES[name];
	});
	
	var TAG_PROPERTIES = exports.TAG_PROPERTIES = {
	    CHARSET: "charset",
	    CSS_TEXT: "cssText",
	    HREF: "href",
	    HTTPEQUIV: "http-equiv",
	    INNER_HTML: "innerHTML",
	    ITEM_PROP: "itemprop",
	    NAME: "name",
	    PROPERTY: "property",
	    REL: "rel",
	    SRC: "src"
	};
	
	var REACT_TAG_MAP = exports.REACT_TAG_MAP = {
	    accesskey: "accessKey",
	    charset: "charSet",
	    class: "className",
	    contenteditable: "contentEditable",
	    contextmenu: "contextMenu",
	    "http-equiv": "httpEquiv",
	    itemprop: "itemProp",
	    tabindex: "tabIndex"
	};
	
	var HELMET_PROPS = exports.HELMET_PROPS = {
	    DEFAULT_TITLE: "defaultTitle",
	    DEFER: "defer",
	    ENCODE_SPECIAL_CHARACTERS: "encodeSpecialCharacters",
	    ON_CHANGE_CLIENT_STATE: "onChangeClientState",
	    TITLE_TEMPLATE: "titleTemplate"
	};
	
	var HTML_TAG_MAP = exports.HTML_TAG_MAP = Object.keys(REACT_TAG_MAP).reduce(function (obj, key) {
	    obj[REACT_TAG_MAP[key]] = key;
	    return obj;
	}, {});
	
	var SELF_CLOSING_TAGS = exports.SELF_CLOSING_TAGS = [TAG_NAMES.NOSCRIPT, TAG_NAMES.SCRIPT, TAG_NAMES.STYLE];
	
	var HELMET_ATTRIBUTE = exports.HELMET_ATTRIBUTE = "data-react-helmet";

/***/ }),

/***/ 430:
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(global) {exports.__esModule = true;
	exports.warn = exports.requestAnimationFrame = exports.reducePropsToState = exports.mapStateOnServer = exports.handleClientStateChange = exports.convertReactPropstoHtmlAttributes = undefined;
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _objectAssign = __webpack_require__(5);
	
	var _objectAssign2 = _interopRequireDefault(_objectAssign);
	
	var _HelmetConstants = __webpack_require__(202);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var encodeSpecialCharacters = function encodeSpecialCharacters(str) {
	    var encode = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;
	
	    if (encode === false) {
	        return String(str);
	    }
	
	    return String(str).replace(/&/g, "&amp;").replace(/</g, "&lt;").replace(/>/g, "&gt;").replace(/"/g, "&quot;").replace(/'/g, "&#x27;");
	};
	
	var getTitleFromPropsList = function getTitleFromPropsList(propsList) {
	    var innermostTitle = getInnermostProperty(propsList, _HelmetConstants.TAG_NAMES.TITLE);
	    var innermostTemplate = getInnermostProperty(propsList, _HelmetConstants.HELMET_PROPS.TITLE_TEMPLATE);
	
	    if (innermostTemplate && innermostTitle) {
	        // use function arg to avoid need to escape $ characters
	        return innermostTemplate.replace(/%s/g, function () {
	            return innermostTitle;
	        });
	    }
	
	    var innermostDefaultTitle = getInnermostProperty(propsList, _HelmetConstants.HELMET_PROPS.DEFAULT_TITLE);
	
	    return innermostTitle || innermostDefaultTitle || undefined;
	};
	
	var getOnChangeClientState = function getOnChangeClientState(propsList) {
	    return getInnermostProperty(propsList, _HelmetConstants.HELMET_PROPS.ON_CHANGE_CLIENT_STATE) || function () {};
	};
	
	var getAttributesFromPropsList = function getAttributesFromPropsList(tagType, propsList) {
	    return propsList.filter(function (props) {
	        return typeof props[tagType] !== "undefined";
	    }).map(function (props) {
	        return props[tagType];
	    }).reduce(function (tagAttrs, current) {
	        return _extends({}, tagAttrs, current);
	    }, {});
	};
	
	var getBaseTagFromPropsList = function getBaseTagFromPropsList(primaryAttributes, propsList) {
	    return propsList.filter(function (props) {
	        return typeof props[_HelmetConstants.TAG_NAMES.BASE] !== "undefined";
	    }).map(function (props) {
	        return props[_HelmetConstants.TAG_NAMES.BASE];
	    }).reverse().reduce(function (innermostBaseTag, tag) {
	        if (!innermostBaseTag.length) {
	            var keys = Object.keys(tag);
	
	            for (var i = 0; i < keys.length; i++) {
	                var attributeKey = keys[i];
	                var lowerCaseAttributeKey = attributeKey.toLowerCase();
	
	                if (primaryAttributes.indexOf(lowerCaseAttributeKey) !== -1 && tag[lowerCaseAttributeKey]) {
	                    return innermostBaseTag.concat(tag);
	                }
	            }
	        }
	
	        return innermostBaseTag;
	    }, []);
	};
	
	var getTagsFromPropsList = function getTagsFromPropsList(tagName, primaryAttributes, propsList) {
	    // Calculate list of tags, giving priority innermost component (end of the propslist)
	    var approvedSeenTags = {};
	
	    return propsList.filter(function (props) {
	        if (Array.isArray(props[tagName])) {
	            return true;
	        }
	        if (typeof props[tagName] !== "undefined") {
	            warn("Helmet: " + tagName + " should be of type \"Array\". Instead found type \"" + _typeof(props[tagName]) + "\"");
	        }
	        return false;
	    }).map(function (props) {
	        return props[tagName];
	    }).reverse().reduce(function (approvedTags, instanceTags) {
	        var instanceSeenTags = {};
	
	        instanceTags.filter(function (tag) {
	            var primaryAttributeKey = void 0;
	            var keys = Object.keys(tag);
	            for (var i = 0; i < keys.length; i++) {
	                var attributeKey = keys[i];
	                var lowerCaseAttributeKey = attributeKey.toLowerCase();
	
	                // Special rule with link tags, since rel and href are both primary tags, rel takes priority
	                if (primaryAttributes.indexOf(lowerCaseAttributeKey) !== -1 && !(primaryAttributeKey === _HelmetConstants.TAG_PROPERTIES.REL && tag[primaryAttributeKey].toLowerCase() === "canonical") && !(lowerCaseAttributeKey === _HelmetConstants.TAG_PROPERTIES.REL && tag[lowerCaseAttributeKey].toLowerCase() === "stylesheet")) {
	                    primaryAttributeKey = lowerCaseAttributeKey;
	                }
	                // Special case for innerHTML which doesn't work lowercased
	                if (primaryAttributes.indexOf(attributeKey) !== -1 && (attributeKey === _HelmetConstants.TAG_PROPERTIES.INNER_HTML || attributeKey === _HelmetConstants.TAG_PROPERTIES.CSS_TEXT || attributeKey === _HelmetConstants.TAG_PROPERTIES.ITEM_PROP)) {
	                    primaryAttributeKey = attributeKey;
	                }
	            }
	
	            if (!primaryAttributeKey || !tag[primaryAttributeKey]) {
	                return false;
	            }
	
	            var value = tag[primaryAttributeKey].toLowerCase();
	
	            if (!approvedSeenTags[primaryAttributeKey]) {
	                approvedSeenTags[primaryAttributeKey] = {};
	            }
	
	            if (!instanceSeenTags[primaryAttributeKey]) {
	                instanceSeenTags[primaryAttributeKey] = {};
	            }
	
	            if (!approvedSeenTags[primaryAttributeKey][value]) {
	                instanceSeenTags[primaryAttributeKey][value] = true;
	                return true;
	            }
	
	            return false;
	        }).reverse().forEach(function (tag) {
	            return approvedTags.push(tag);
	        });
	
	        // Update seen tags with tags from this instance
	        var keys = Object.keys(instanceSeenTags);
	        for (var i = 0; i < keys.length; i++) {
	            var attributeKey = keys[i];
	            var tagUnion = (0, _objectAssign2.default)({}, approvedSeenTags[attributeKey], instanceSeenTags[attributeKey]);
	
	            approvedSeenTags[attributeKey] = tagUnion;
	        }
	
	        return approvedTags;
	    }, []).reverse();
	};
	
	var getInnermostProperty = function getInnermostProperty(propsList, property) {
	    for (var i = propsList.length - 1; i >= 0; i--) {
	        var props = propsList[i];
	
	        if (props.hasOwnProperty(property)) {
	            return props[property];
	        }
	    }
	
	    return null;
	};
	
	var reducePropsToState = function reducePropsToState(propsList) {
	    return {
	        baseTag: getBaseTagFromPropsList([_HelmetConstants.TAG_PROPERTIES.HREF], propsList),
	        bodyAttributes: getAttributesFromPropsList(_HelmetConstants.ATTRIBUTE_NAMES.BODY, propsList),
	        defer: getInnermostProperty(propsList, _HelmetConstants.HELMET_PROPS.DEFER),
	        encode: getInnermostProperty(propsList, _HelmetConstants.HELMET_PROPS.ENCODE_SPECIAL_CHARACTERS),
	        htmlAttributes: getAttributesFromPropsList(_HelmetConstants.ATTRIBUTE_NAMES.HTML, propsList),
	        linkTags: getTagsFromPropsList(_HelmetConstants.TAG_NAMES.LINK, [_HelmetConstants.TAG_PROPERTIES.REL, _HelmetConstants.TAG_PROPERTIES.HREF], propsList),
	        metaTags: getTagsFromPropsList(_HelmetConstants.TAG_NAMES.META, [_HelmetConstants.TAG_PROPERTIES.NAME, _HelmetConstants.TAG_PROPERTIES.CHARSET, _HelmetConstants.TAG_PROPERTIES.HTTPEQUIV, _HelmetConstants.TAG_PROPERTIES.PROPERTY, _HelmetConstants.TAG_PROPERTIES.ITEM_PROP], propsList),
	        noscriptTags: getTagsFromPropsList(_HelmetConstants.TAG_NAMES.NOSCRIPT, [_HelmetConstants.TAG_PROPERTIES.INNER_HTML], propsList),
	        onChangeClientState: getOnChangeClientState(propsList),
	        scriptTags: getTagsFromPropsList(_HelmetConstants.TAG_NAMES.SCRIPT, [_HelmetConstants.TAG_PROPERTIES.SRC, _HelmetConstants.TAG_PROPERTIES.INNER_HTML], propsList),
	        styleTags: getTagsFromPropsList(_HelmetConstants.TAG_NAMES.STYLE, [_HelmetConstants.TAG_PROPERTIES.CSS_TEXT], propsList),
	        title: getTitleFromPropsList(propsList),
	        titleAttributes: getAttributesFromPropsList(_HelmetConstants.ATTRIBUTE_NAMES.TITLE, propsList)
	    };
	};
	
	var rafPolyfill = function () {
	    var clock = Date.now();
	
	    return function (callback) {
	        var currentTime = Date.now();
	
	        if (currentTime - clock > 16) {
	            clock = currentTime;
	            callback(currentTime);
	        } else {
	            setTimeout(function () {
	                rafPolyfill(callback);
	            }, 0);
	        }
	    };
	}();
	
	var cafPolyfill = function cafPolyfill(id) {
	    return clearTimeout(id);
	};
	
	var requestAnimationFrame = typeof window !== "undefined" ? window.requestAnimationFrame || window.webkitRequestAnimationFrame || window.mozRequestAnimationFrame || rafPolyfill : global.requestAnimationFrame || rafPolyfill;
	
	var cancelAnimationFrame = typeof window !== "undefined" ? window.cancelAnimationFrame || window.webkitCancelAnimationFrame || window.mozCancelAnimationFrame || cafPolyfill : global.cancelAnimationFrame || cafPolyfill;
	
	var warn = function warn(msg) {
	    return console && typeof console.warn === "function" && console.warn(msg);
	};
	
	var _helmetCallback = null;
	
	var handleClientStateChange = function handleClientStateChange(newState) {
	    if (_helmetCallback) {
	        cancelAnimationFrame(_helmetCallback);
	    }
	
	    if (newState.defer) {
	        _helmetCallback = requestAnimationFrame(function () {
	            commitTagChanges(newState, function () {
	                _helmetCallback = null;
	            });
	        });
	    } else {
	        commitTagChanges(newState);
	        _helmetCallback = null;
	    }
	};
	
	var commitTagChanges = function commitTagChanges(newState, cb) {
	    var baseTag = newState.baseTag,
	        bodyAttributes = newState.bodyAttributes,
	        htmlAttributes = newState.htmlAttributes,
	        linkTags = newState.linkTags,
	        metaTags = newState.metaTags,
	        noscriptTags = newState.noscriptTags,
	        onChangeClientState = newState.onChangeClientState,
	        scriptTags = newState.scriptTags,
	        styleTags = newState.styleTags,
	        title = newState.title,
	        titleAttributes = newState.titleAttributes;
	
	    updateAttributes(_HelmetConstants.TAG_NAMES.BODY, bodyAttributes);
	    updateAttributes(_HelmetConstants.TAG_NAMES.HTML, htmlAttributes);
	
	    updateTitle(title, titleAttributes);
	
	    var tagUpdates = {
	        baseTag: updateTags(_HelmetConstants.TAG_NAMES.BASE, baseTag),
	        linkTags: updateTags(_HelmetConstants.TAG_NAMES.LINK, linkTags),
	        metaTags: updateTags(_HelmetConstants.TAG_NAMES.META, metaTags),
	        noscriptTags: updateTags(_HelmetConstants.TAG_NAMES.NOSCRIPT, noscriptTags),
	        scriptTags: updateTags(_HelmetConstants.TAG_NAMES.SCRIPT, scriptTags),
	        styleTags: updateTags(_HelmetConstants.TAG_NAMES.STYLE, styleTags)
	    };
	
	    var addedTags = {};
	    var removedTags = {};
	
	    Object.keys(tagUpdates).forEach(function (tagType) {
	        var _tagUpdates$tagType = tagUpdates[tagType],
	            newTags = _tagUpdates$tagType.newTags,
	            oldTags = _tagUpdates$tagType.oldTags;
	
	
	        if (newTags.length) {
	            addedTags[tagType] = newTags;
	        }
	        if (oldTags.length) {
	            removedTags[tagType] = tagUpdates[tagType].oldTags;
	        }
	    });
	
	    cb && cb();
	
	    onChangeClientState(newState, addedTags, removedTags);
	};
	
	var flattenArray = function flattenArray(possibleArray) {
	    return Array.isArray(possibleArray) ? possibleArray.join("") : possibleArray;
	};
	
	var updateTitle = function updateTitle(title, attributes) {
	    if (typeof title !== "undefined" && document.title !== title) {
	        document.title = flattenArray(title);
	    }
	
	    updateAttributes(_HelmetConstants.TAG_NAMES.TITLE, attributes);
	};
	
	var updateAttributes = function updateAttributes(tagName, attributes) {
	    var elementTag = document.getElementsByTagName(tagName)[0];
	
	    if (!elementTag) {
	        return;
	    }
	
	    var helmetAttributeString = elementTag.getAttribute(_HelmetConstants.HELMET_ATTRIBUTE);
	    var helmetAttributes = helmetAttributeString ? helmetAttributeString.split(",") : [];
	    var attributesToRemove = [].concat(helmetAttributes);
	    var attributeKeys = Object.keys(attributes);
	
	    for (var i = 0; i < attributeKeys.length; i++) {
	        var attribute = attributeKeys[i];
	        var value = attributes[attribute] || "";
	
	        if (elementTag.getAttribute(attribute) !== value) {
	            elementTag.setAttribute(attribute, value);
	        }
	
	        if (helmetAttributes.indexOf(attribute) === -1) {
	            helmetAttributes.push(attribute);
	        }
	
	        var indexToSave = attributesToRemove.indexOf(attribute);
	        if (indexToSave !== -1) {
	            attributesToRemove.splice(indexToSave, 1);
	        }
	    }
	
	    for (var _i = attributesToRemove.length - 1; _i >= 0; _i--) {
	        elementTag.removeAttribute(attributesToRemove[_i]);
	    }
	
	    if (helmetAttributes.length === attributesToRemove.length) {
	        elementTag.removeAttribute(_HelmetConstants.HELMET_ATTRIBUTE);
	    } else if (elementTag.getAttribute(_HelmetConstants.HELMET_ATTRIBUTE) !== attributeKeys.join(",")) {
	        elementTag.setAttribute(_HelmetConstants.HELMET_ATTRIBUTE, attributeKeys.join(","));
	    }
	};
	
	var updateTags = function updateTags(type, tags) {
	    var headElement = document.head || document.querySelector(_HelmetConstants.TAG_NAMES.HEAD);
	    var tagNodes = headElement.querySelectorAll(type + "[" + _HelmetConstants.HELMET_ATTRIBUTE + "]");
	    var oldTags = Array.prototype.slice.call(tagNodes);
	    var newTags = [];
	    var indexToDelete = void 0;
	
	    if (tags && tags.length) {
	        tags.forEach(function (tag) {
	            var newElement = document.createElement(type);
	
	            for (var attribute in tag) {
	                if (tag.hasOwnProperty(attribute)) {
	                    if (attribute === _HelmetConstants.TAG_PROPERTIES.INNER_HTML) {
	                        newElement.innerHTML = tag.innerHTML;
	                    } else if (attribute === _HelmetConstants.TAG_PROPERTIES.CSS_TEXT) {
	                        if (newElement.styleSheet) {
	                            newElement.styleSheet.cssText = tag.cssText;
	                        } else {
	                            newElement.appendChild(document.createTextNode(tag.cssText));
	                        }
	                    } else {
	                        var value = typeof tag[attribute] === "undefined" ? "" : tag[attribute];
	                        newElement.setAttribute(attribute, value);
	                    }
	                }
	            }
	
	            newElement.setAttribute(_HelmetConstants.HELMET_ATTRIBUTE, "true");
	
	            // Remove a duplicate tag from domTagstoRemove, so it isn't cleared.
	            if (oldTags.some(function (existingTag, index) {
	                indexToDelete = index;
	                return newElement.isEqualNode(existingTag);
	            })) {
	                oldTags.splice(indexToDelete, 1);
	            } else {
	                newTags.push(newElement);
	            }
	        });
	    }
	
	    oldTags.forEach(function (tag) {
	        return tag.parentNode.removeChild(tag);
	    });
	    newTags.forEach(function (tag) {
	        return headElement.appendChild(tag);
	    });
	
	    return {
	        oldTags: oldTags,
	        newTags: newTags
	    };
	};
	
	var generateElementAttributesAsString = function generateElementAttributesAsString(attributes) {
	    return Object.keys(attributes).reduce(function (str, key) {
	        var attr = typeof attributes[key] !== "undefined" ? key + "=\"" + attributes[key] + "\"" : "" + key;
	        return str ? str + " " + attr : attr;
	    }, "");
	};
	
	var generateTitleAsString = function generateTitleAsString(type, title, attributes, encode) {
	    var attributeString = generateElementAttributesAsString(attributes);
	    var flattenedTitle = flattenArray(title);
	    return attributeString ? "<" + type + " " + _HelmetConstants.HELMET_ATTRIBUTE + "=\"true\" " + attributeString + ">" + encodeSpecialCharacters(flattenedTitle, encode) + "</" + type + ">" : "<" + type + " " + _HelmetConstants.HELMET_ATTRIBUTE + "=\"true\">" + encodeSpecialCharacters(flattenedTitle, encode) + "</" + type + ">";
	};
	
	var generateTagsAsString = function generateTagsAsString(type, tags, encode) {
	    return tags.reduce(function (str, tag) {
	        var attributeHtml = Object.keys(tag).filter(function (attribute) {
	            return !(attribute === _HelmetConstants.TAG_PROPERTIES.INNER_HTML || attribute === _HelmetConstants.TAG_PROPERTIES.CSS_TEXT);
	        }).reduce(function (string, attribute) {
	            var attr = typeof tag[attribute] === "undefined" ? attribute : attribute + "=\"" + encodeSpecialCharacters(tag[attribute], encode) + "\"";
	            return string ? string + " " + attr : attr;
	        }, "");
	
	        var tagContent = tag.innerHTML || tag.cssText || "";
	
	        var isSelfClosing = _HelmetConstants.SELF_CLOSING_TAGS.indexOf(type) === -1;
	
	        return str + "<" + type + " " + _HelmetConstants.HELMET_ATTRIBUTE + "=\"true\" " + attributeHtml + (isSelfClosing ? "/>" : ">" + tagContent + "</" + type + ">");
	    }, "");
	};
	
	var convertElementAttributestoReactProps = function convertElementAttributestoReactProps(attributes) {
	    var initProps = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
	
	    return Object.keys(attributes).reduce(function (obj, key) {
	        obj[_HelmetConstants.REACT_TAG_MAP[key] || key] = attributes[key];
	        return obj;
	    }, initProps);
	};
	
	var convertReactPropstoHtmlAttributes = function convertReactPropstoHtmlAttributes(props) {
	    var initAttributes = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
	
	    return Object.keys(props).reduce(function (obj, key) {
	        obj[_HelmetConstants.HTML_TAG_MAP[key] || key] = props[key];
	        return obj;
	    }, initAttributes);
	};
	
	var generateTitleAsReactComponent = function generateTitleAsReactComponent(type, title, attributes) {
	    var _initProps;
	
	    // assigning into an array to define toString function on it
	    var initProps = (_initProps = {
	        key: title
	    }, _initProps[_HelmetConstants.HELMET_ATTRIBUTE] = true, _initProps);
	    var props = convertElementAttributestoReactProps(attributes, initProps);
	
	    return [_react2.default.createElement(_HelmetConstants.TAG_NAMES.TITLE, props, title)];
	};
	
	var generateTagsAsReactComponent = function generateTagsAsReactComponent(type, tags) {
	    return tags.map(function (tag, i) {
	        var _mappedTag;
	
	        var mappedTag = (_mappedTag = {
	            key: i
	        }, _mappedTag[_HelmetConstants.HELMET_ATTRIBUTE] = true, _mappedTag);
	
	        Object.keys(tag).forEach(function (attribute) {
	            var mappedAttribute = _HelmetConstants.REACT_TAG_MAP[attribute] || attribute;
	
	            if (mappedAttribute === _HelmetConstants.TAG_PROPERTIES.INNER_HTML || mappedAttribute === _HelmetConstants.TAG_PROPERTIES.CSS_TEXT) {
	                var content = tag.innerHTML || tag.cssText;
	                mappedTag.dangerouslySetInnerHTML = { __html: content };
	            } else {
	                mappedTag[mappedAttribute] = tag[attribute];
	            }
	        });
	
	        return _react2.default.createElement(type, mappedTag);
	    });
	};
	
	var getMethodsForTag = function getMethodsForTag(type, tags, encode) {
	    switch (type) {
	        case _HelmetConstants.TAG_NAMES.TITLE:
	            return {
	                toComponent: function toComponent() {
	                    return generateTitleAsReactComponent(type, tags.title, tags.titleAttributes, encode);
	                },
	                toString: function toString() {
	                    return generateTitleAsString(type, tags.title, tags.titleAttributes, encode);
	                }
	            };
	        case _HelmetConstants.ATTRIBUTE_NAMES.BODY:
	        case _HelmetConstants.ATTRIBUTE_NAMES.HTML:
	            return {
	                toComponent: function toComponent() {
	                    return convertElementAttributestoReactProps(tags);
	                },
	                toString: function toString() {
	                    return generateElementAttributesAsString(tags);
	                }
	            };
	        default:
	            return {
	                toComponent: function toComponent() {
	                    return generateTagsAsReactComponent(type, tags);
	                },
	                toString: function toString() {
	                    return generateTagsAsString(type, tags, encode);
	                }
	            };
	    }
	};
	
	var mapStateOnServer = function mapStateOnServer(_ref) {
	    var baseTag = _ref.baseTag,
	        bodyAttributes = _ref.bodyAttributes,
	        encode = _ref.encode,
	        htmlAttributes = _ref.htmlAttributes,
	        linkTags = _ref.linkTags,
	        metaTags = _ref.metaTags,
	        noscriptTags = _ref.noscriptTags,
	        scriptTags = _ref.scriptTags,
	        styleTags = _ref.styleTags,
	        _ref$title = _ref.title,
	        title = _ref$title === undefined ? "" : _ref$title,
	        titleAttributes = _ref.titleAttributes;
	    return {
	        base: getMethodsForTag(_HelmetConstants.TAG_NAMES.BASE, baseTag, encode),
	        bodyAttributes: getMethodsForTag(_HelmetConstants.ATTRIBUTE_NAMES.BODY, bodyAttributes, encode),
	        htmlAttributes: getMethodsForTag(_HelmetConstants.ATTRIBUTE_NAMES.HTML, htmlAttributes, encode),
	        link: getMethodsForTag(_HelmetConstants.TAG_NAMES.LINK, linkTags, encode),
	        meta: getMethodsForTag(_HelmetConstants.TAG_NAMES.META, metaTags, encode),
	        noscript: getMethodsForTag(_HelmetConstants.TAG_NAMES.NOSCRIPT, noscriptTags, encode),
	        script: getMethodsForTag(_HelmetConstants.TAG_NAMES.SCRIPT, scriptTags, encode),
	        style: getMethodsForTag(_HelmetConstants.TAG_NAMES.STYLE, styleTags, encode),
	        title: getMethodsForTag(_HelmetConstants.TAG_NAMES.TITLE, { title: title, titleAttributes: titleAttributes }, encode)
	    };
	};
	
	exports.convertReactPropstoHtmlAttributes = convertReactPropstoHtmlAttributes;
	exports.handleClientStateChange = handleClientStateChange;
	exports.mapStateOnServer = mapStateOnServer;
	exports.reducePropsToState = reducePropsToState;
	exports.requestAnimationFrame = requestAnimationFrame;
	exports.warn = warn;
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }())))

/***/ }),

/***/ 448:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	function _interopDefault (ex) { return (ex && (typeof ex === 'object') && 'default' in ex) ? ex['default'] : ex; }
	
	var React = __webpack_require__(1);
	var React__default = _interopDefault(React);
	var ExecutionEnvironment = _interopDefault(__webpack_require__(318));
	var shallowEqual = _interopDefault(__webpack_require__(465));
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	function withSideEffect(reducePropsToState, handleStateChangeOnClient, mapStateOnServer) {
	  if (typeof reducePropsToState !== 'function') {
	    throw new Error('Expected reducePropsToState to be a function.');
	  }
	  if (typeof handleStateChangeOnClient !== 'function') {
	    throw new Error('Expected handleStateChangeOnClient to be a function.');
	  }
	  if (typeof mapStateOnServer !== 'undefined' && typeof mapStateOnServer !== 'function') {
	    throw new Error('Expected mapStateOnServer to either be undefined or a function.');
	  }
	
	  function getDisplayName(WrappedComponent) {
	    return WrappedComponent.displayName || WrappedComponent.name || 'Component';
	  }
	
	  return function wrap(WrappedComponent) {
	    if (typeof WrappedComponent !== 'function') {
	      throw new Error('Expected WrappedComponent to be a React component.');
	    }
	
	    var mountedInstances = [];
	    var state = void 0;
	
	    function emitChange() {
	      state = reducePropsToState(mountedInstances.map(function (instance) {
	        return instance.props;
	      }));
	
	      if (SideEffect.canUseDOM) {
	        handleStateChangeOnClient(state);
	      } else if (mapStateOnServer) {
	        state = mapStateOnServer(state);
	      }
	    }
	
	    var SideEffect = function (_Component) {
	      _inherits(SideEffect, _Component);
	
	      function SideEffect() {
	        _classCallCheck(this, SideEffect);
	
	        return _possibleConstructorReturn(this, _Component.apply(this, arguments));
	      }
	
	      // Try to use displayName of wrapped component
	      SideEffect.peek = function peek() {
	        return state;
	      };
	
	      // Expose canUseDOM so tests can monkeypatch it
	
	
	      SideEffect.rewind = function rewind() {
	        if (SideEffect.canUseDOM) {
	          throw new Error('You may only call rewind() on the server. Call peek() to read the current state.');
	        }
	
	        var recordedState = state;
	        state = undefined;
	        mountedInstances = [];
	        return recordedState;
	      };
	
	      SideEffect.prototype.shouldComponentUpdate = function shouldComponentUpdate(nextProps) {
	        return !shallowEqual(nextProps, this.props);
	      };
	
	      SideEffect.prototype.componentWillMount = function componentWillMount() {
	        mountedInstances.push(this);
	        emitChange();
	      };
	
	      SideEffect.prototype.componentDidUpdate = function componentDidUpdate() {
	        emitChange();
	      };
	
	      SideEffect.prototype.componentWillUnmount = function componentWillUnmount() {
	        var index = mountedInstances.indexOf(this);
	        mountedInstances.splice(index, 1);
	        emitChange();
	      };
	
	      SideEffect.prototype.render = function render() {
	        return React__default.createElement(WrappedComponent, this.props);
	      };
	
	      return SideEffect;
	    }(React.Component);
	
	    SideEffect.displayName = 'SideEffect(' + getDisplayName(WrappedComponent) + ')';
	    SideEffect.canUseDOM = ExecutionEnvironment.canUseDOM;
	
	
	    return SideEffect;
	  };
	}
	
	module.exports = withSideEffect;


/***/ }),

/***/ 465:
/***/ (function(module, exports) {

	//
	
	module.exports = function shallowEqual(objA, objB, compare, compareContext) {
	  var ret = compare ? compare.call(compareContext, objA, objB) : void 0;
	
	  if (ret !== void 0) {
	    return !!ret;
	  }
	
	  if (objA === objB) {
	    return true;
	  }
	
	  if (typeof objA !== "object" || !objA || typeof objB !== "object" || !objB) {
	    return false;
	  }
	
	  var keysA = Object.keys(objA);
	  var keysB = Object.keys(objB);
	
	  if (keysA.length !== keysB.length) {
	    return false;
	  }
	
	  var bHasOwnProperty = Object.prototype.hasOwnProperty.bind(objB);
	
	  // Test for A's keys different from B.
	  for (var idx = 0; idx < keysA.length; idx++) {
	    var key = keysA[idx];
	
	    if (!bHasOwnProperty(key)) {
	      return false;
	    }
	
	    var valueA = objA[key];
	    var valueB = objB[key];
	
	    ret = compare ? compare.call(compareContext, valueA, valueB, key) : void 0;
	
	    if (ret === false || (ret === void 0 && valueA !== valueB)) {
	      return false;
	    }
	  }
	
	  return true;
	};


/***/ }),

/***/ 92:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _Davos_logo = __webpack_require__(12);
	
	var _Davos_logo2 = _interopRequireDefault(_Davos_logo);
	
	var _Davos_slogan = __webpack_require__(14);
	
	var _Davos_slogan2 = _interopRequireDefault(_Davos_slogan);
	
	var _facebook = __webpack_require__(15);
	
	var _facebook2 = _interopRequireDefault(_facebook);
	
	var _twitter = __webpack_require__(17);
	
	var _twitter2 = _interopRequireDefault(_twitter);
	
	var _instagram = __webpack_require__(16);
	
	var _instagram2 = _interopRequireDefault(_instagram);
	
	var _maple_leafRed = __webpack_require__(66);
	
	var _maple_leafRed2 = _interopRequireDefault(_maple_leafRed);
	
	var _VentureConnection_LOGO = __webpack_require__(64);
	
	var _VentureConnection_LOGO2 = _interopRequireDefault(_VentureConnection_LOGO);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var Footer = function Footer() {
	  return _react2.default.createElement(
	    "div",
	    { className: "" },
	    _react2.default.createElement(
	      "div",
	      { className: "py-5 footer-padded bg-purple-footer-image relative z-10" },
	      _react2.default.createElement(
	        "div",
	        { className: "max-w-3xl mx-auto p4 flex pt-15 sm:flex-wrap sm:flex-col md:flex-wrap md:flex-col" },
	        _react2.default.createElement(
	          "div",
	          { className: "w-1/3 text-white ml-4 mr-8 text-center text-xl mt-12 sm:w-full sm:mx-auto md:w-3/4 md:text-left md:mx-auto md:pt-8" },
	          _react2.default.createElement(
	            "h1",
	            { className: "sm:text-2xl md:mb-8 md:pt-8" },
	            "Discover if Davos ",
	            _react2.default.createElement("br", null),
	            "is right for you!"
	          )
	        ),
	        _react2.default.createElement(
	          "div",
	          { className: "w-1/3 mx-auto mt-2 pt-2 sm:w-full md:w-3/4 md:text-left md:mx-auto" },
	          _react2.default.createElement(
	            "p",
	            { className: "text-white text-lg leading-normal sm:text-center sm:px-8" },
	            "Request early access and get our latest updates and news before anyone else!"
	          ),
	          _react2.default.createElement(
	            "form",
	            { name: "sign up", method: "POST", action: "/success#submitted", className: "pt-6 pb-8 mb-4 sm:px-8 sm:mt-8", "data-netlify": "true", "data-netlify-honeypot": "bot-field" },
	            _react2.default.createElement("input", { type: "hidden", name: "bot-field" }),
	            _react2.default.createElement(
	              "div",
	              { className: "mb-4" },
	              _react2.default.createElement("input", { className: "shadow appearance-none border rounded-full w-full py-2 px-4 text-purple-dark leading-tight focus:outline-none focus:shadow-outline", id: "name", type: "text", placeholder: "Name", name: "name" })
	            ),
	            _react2.default.createElement(
	              "div",
	              { className: "mb-4" },
	              _react2.default.createElement("input", { className: "shadow appearance-none border rounded-full w-full py-2 px-4 text-purple-dark leading-tight focus:outline-none focus:shadow-outline", id: "email", type: "text", placeholder: "Email Address", name: "email" })
	            ),
	            _react2.default.createElement(
	              "div",
	              { className: "w-full" },
	              _react2.default.createElement(
	                "button",
	                { className: "w-full rounded-full bg-purple-light uppercase text-white font-bold py-2 px-4 rounded focus:outline-none focus:shadow-outline tracking-wide", type: "submit" },
	                "Request early access"
	              )
	            )
	          )
	        )
	      )
	    ),
	    _react2.default.createElement(
	      "div",
	      { className: "sm:text-center lg:pb-8 lg:pt-8 bg-purple-darkest relative footer" },
	      _react2.default.createElement(
	        "div",
	        { className: "flex justify-between items-end max-w-3xl mx-auto p-4 md:pl-8 text-sm sm:flex-wrap sm:flex-col md:items-right" },
	        _react2.default.createElement(
	          "div",
	          { className: "text-white leading-normal w-1/3 sm:w-full sm:leading-loose md:w-1/2 md:ml-8 sm:pb-8" },
	          _react2.default.createElement("img", { src: _maple_leafRed2.default, className: "w-6 mb-4" }),
	          _react2.default.createElement(
	            "p",
	            { className: "leading-loose w-4/5 sm:w-full" },
	            "A proudly Canadian Startup currently working with SFU's Coast Capital Savings Venture Connection."
	          ),
	          _react2.default.createElement(
	            "a",
	            { href: "http://www.sfu.ca/io/venture/venture-connection.html", target: "_blank" },
	            _react2.default.createElement("img", { src: _VentureConnection_LOGO2.default, className: "w-4/5" })
	          )
	        ),
	        _react2.default.createElement(
	          "div",
	          { className: "pb-8" },
	          _react2.default.createElement(
	            "div",
	            { className: "flex items-center mb-6" },
	            _react2.default.createElement("img", { src: _Davos_logo2.default, className: "w-48 mr-8 md:w-32" }),
	            _react2.default.createElement("img", { src: _Davos_slogan2.default, className: "w-1/3" })
	          ),
	          _react2.default.createElement(
	            "div",
	            { className: "flex items-center sm:flex-wrap sm:flex-col md:w-3/4" },
	            _react2.default.createElement(
	              "p",
	              { className: "text-white flex-1 sm:mb-4" },
	              "Contact Us! ",
	              _react2.default.createElement(
	                "a",
	                { className: "text-white no-underline font-bold", href: "mailto:info@davos.gives" },
	                "info@davos.gives"
	              )
	            ),
	            _react2.default.createElement(
	              "div",
	              { className: "flex flex-wrap flex-1 sm:justify-center sm:mb-8 md:justify-end" },
	              _react2.default.createElement(
	                "div",
	                { className: "bg-white text-white rounded-full h-8 w-8 flex items-center justify-center mr-3" },
	                _react2.default.createElement(
	                  "a",
	                  { href: "https://www.facebook.com/davos.gives/", target: "_blank" },
	                  _react2.default.createElement("img", { src: _facebook2.default, className: "w-4 pt-1" })
	                )
	              ),
	              _react2.default.createElement(
	                "div",
	                { className: "bg-white text-white rounded-full h-8 w-8 flex items-center justify-center mr-3" },
	                _react2.default.createElement(
	                  "a",
	                  { href: "https://twitter.com/Davos_Gives", target: "_blank" },
	                  _react2.default.createElement("img", { src: _twitter2.default, className: "w-4 pt-1" })
	                )
	              ),
	              _react2.default.createElement(
	                "div",
	                { className: "bg-white text-white rounded-full h-8 w-8 flex items-center justify-center" },
	                _react2.default.createElement(
	                  "a",
	                  { href: "https://www.instagram.com/davos.gives/", target: "_blank" },
	                  _react2.default.createElement("img", { src: _instagram2.default, className: "w-4 pt-1" })
	                )
	              )
	            )
	          )
	        )
	      )
	    )
	  );
	};
	
	exports.default = Footer;
	module.exports = exports["default"];

/***/ }),

/***/ 223:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _gatsbyLink = __webpack_require__(22);
	
	var _gatsbyLink2 = _interopRequireDefault(_gatsbyLink);
	
	var _Davos_logo = __webpack_require__(12);
	
	var _Davos_logo2 = _interopRequireDefault(_Davos_logo);
	
	var _Landing_Illustration = __webpack_require__(466);
	
	var _Landing_Illustration2 = _interopRequireDefault(_Landing_Illustration);
	
	var _maple_leaf = __webpack_require__(470);
	
	var _maple_leaf2 = _interopRequireDefault(_maple_leaf);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var Header = function Header() {
	  var handleClick = function handleClick(e) {
	    var el = document.getElementById("nav");
	
	    e.preventDefault();
	    el.classList.toggle("block");
	    el.classList.toggle("hidden");
	  };
	
	  return _react2.default.createElement(
	    "nav",
	    { className: "bg-purple-image" },
	    _react2.default.createElement(
	      "div",
	      { className: "flex sm:flex-wrap md:flex-wrap items-center justify-between max-w-3xl mx-auto sm:px-0 px-4 pb-8 sm:pb-0 md:max-w-2xl md:pt-8 md:mt-8" },
	      _react2.default.createElement(
	        "div",
	        { className: "w-1/2 sm:w-full text-white mb-8 pb-8 sm:pb-0 sm:mb-0 sm:px-8 md:mx-auto md:w-3/4" },
	        _react2.default.createElement("img", { src: _Davos_logo2.default, className: "w-64 h-32 -mt-8 sm:w-32 md:w-32" }),
	        _react2.default.createElement(
	          "h1",
	          { className: "capitalize mb-4 sm:text-2xl sm:text-center md:leading-normal" },
	          "the new standard",
	          _react2.default.createElement("br", null),
	          " in online fundraising"
	        ),
	        _react2.default.createElement(
	          "p",
	          { className: "leading-normal text-lg mb-8 sm:text-center sm:m-auto sm:w-64 sm:leading-loose md:w-2/3 md:leading-loose" },
	          "Davos is an easy-to-use online fundraising platform created for small and medium-sized charities in Canada.",
	          _react2.default.createElement("img", { src: _maple_leaf2.default, className: "w-6 sm:leading-none", style: { position: "relative", left: "10px", top: "15px" } })
	        ),
	        _react2.default.createElement(
	          "button",
	          { className: "bg-purple-light text-white font-bold py-3 px-5 rounded-full capitalize mt-4 mb-8 focus:outline-none focus:shadow-outline sm:m-auto sm:block sm:mt-4" },
	          _react2.default.createElement(
	            "a",
	            { className: "text-white no-underline", href: "#more-info" },
	            "Learn more"
	          )
	        )
	      ),
	      _react2.default.createElement(
	        "div",
	        { className: "w-4/5 sm:w-full sm:pb-0 md:-mt-8 md:mx-auto" },
	        _react2.default.createElement("img", { src: _Landing_Illustration2.default, className: "relative pin-r pin-b mb-8 pb-8 sm:mb-0 sm:pb-0 md:-mt-8" })
	      )
	    )
	  );
	};
	
	exports.default = Header;
	module.exports = exports["default"];

/***/ }),

/***/ 12:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/Davos_logo.32d9a3c1.svg";

/***/ }),

/***/ 14:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/Davos_slogan.ae527489.svg";

/***/ }),

/***/ 466:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/Landing_Illustration-02.55b4641d.png";

/***/ }),

/***/ 64:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/VentureConnection_LOGO.e3dee0b0.png";

/***/ }),

/***/ 467:
/***/ (function(module, exports) {

	module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACAAAAAgCAYAAABzenr0AAAACXBIWXMAAAsSAAALEgHS3X78AAACK0lEQVRYheWXvU7cQBSFPxCJQCngDUBKFwqwRM82bpAitkgPCR0Fwi0NpKPzpkkbKAgtpHUReIF4eYOlSQ0SJWjRSNfiMnM9eFl+IuVUnjMznjP31x7p9/u8JkZf9fR/QcBYwAyINMlawCYwJTv3ijLfexEBaZLNA789esaJCBbXYFgXtAIGpgMmgucQcB4wEQwrYCpg4CRgIhhWgOXrgQQ0KkRpkrmbtoFVoCuR3pW5HWAbuAQ6RZnvqD0dsVJX5i4eK8Ad/ENRzs/z1gvVniNgWVFfK3EaTV3Q9sbTYg0Tkp7L3pwVsI0FWH71RWlsBgwcBcyQAhbFz/eg4uXpBEjAWfltucFxkx53WpR5L1hZJyBNsvU0yX6lSTajaOsGlgDL/Fa62gLSJDsAvgEfgT9qqhPshjlpRtXeVk0ptsTbAoBZ1aTeSUQjJjwNVt8XFqQZcBxLV6sbjqvnt8AG8EXGzpSL3npnBcf3jDlit3ewLLDvjT9VD9LnrWBckWpowcqgqIBD4EaNJ9Ik02lVG1AGzuqiv1aAbPirKOemXTXuSN1vgu5DawIBgl3PCu+raJeAsjLCQtT8tQKKMv8OXClqzDu0qRUebQGHLeBajT9UhamhFc6rlh1DTMBPzw3ojiat9SzYdQerSgaoFSC3XFNWeCNfvBptI22daz4XZd7oy+jBDxLXE4AlGS5YZpUOuCrF6CRW+QYWIAe4BnMxyA/Hkwp4TvznP6fALTQ3st1eMIUfAAAAAElFTkSuQmCC"

/***/ }),

/***/ 468:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/davos_share.ef840e9a.png";

/***/ }),

/***/ 15:
/***/ (function(module, exports) {

	module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAADsAAAA1CAYAAAD/L5PDAAABS2lUWHRYTUw6Y29tLmFkb2JlLnhtcAAAAAAAPD94cGFja2V0IGJlZ2luPSLvu78iIGlkPSJXNU0wTXBDZWhpSHpyZVN6TlRjemtjOWQiPz4KPHg6eG1wbWV0YSB4bWxuczp4PSJhZG9iZTpuczptZXRhLyIgeDp4bXB0az0iQWRvYmUgWE1QIENvcmUgNS42LWMxNDAgNzkuMTYwNDUxLCAyMDE3LzA1LzA2LTAxOjA4OjIxICAgICAgICAiPgogPHJkZjpSREYgeG1sbnM6cmRmPSJodHRwOi8vd3d3LnczLm9yZy8xOTk5LzAyLzIyLXJkZi1zeW50YXgtbnMjIj4KICA8cmRmOkRlc2NyaXB0aW9uIHJkZjphYm91dD0iIi8+CiA8L3JkZjpSREY+CjwveDp4bXBtZXRhPgo8P3hwYWNrZXQgZW5kPSJyIj8+LUNEtwAABENJREFUaIHtmltvG0UUx3+zl9nZ9TXBcds0NKJQRKDigVSUIl5oX+gHgC+IeOOhD6g8cVFVCYEKQlyiSA0qdeIQJ66TOI4ve+UhOJWbqrbX2ZQ4/kv7YM/sOeevMzPnsiOiKIo4I9BetgEnCeMklUVRRBiGeJ5Hu92m0+ngeR6e5xEEAWEYEkURURQhhABACHH4KKXIZrMopTAMA00bzlfiJJdxEAR4nsfu7i6VSoWtrS3KSzrVv3I0Kzn8epqgZR+SFaaHZvhoqoMmPS59WOLarSKzs7M4joOUcij9J+LZIAhwXZdGo0GtVmNzc5OVBxHln16jtXKZcH8wOSu1PG8sLlMoFFBKDW3HiZB1XZednR1WV1f54UudzXsfENbNoeUEtWl83ycMw1h2JEo2DEOCIKBer1Mqlfj5bsTGV+/Hl9ciNlFImGwQBDSbTSqVCvc/t6l++26S6voi0dDjui61Wo211Q2q349OVIzomkTJtlotyuUyS1+fh/irrwfdkBQHiSzjbjRrt9s8/tNj+8HCUO9rKRCqdfDD8A4JnruxTD6fR0o5dIyFhPes67ps/P7KwCdv/qMl3vu0TKFQQEqJruvAU28qVSSXy+E4DoYxvOmJkvV9n8ZaYaC5uevLLH62zpUrb1IsFnvIHhcS27Pd1NCvZwaa/9btNebn50dapv2QeJyNvP4qhISZizbT09MopY7do10k6tlB025hgmEasZL7YZB4iTeIZwE0TUPTNYgfWfrrSE70/w8TsuOKWKdxEAT4vk+z2WR3d5d2u90z3j2cHv9dJqy/01deuA+P/thD1x9iSevIaazrOlJKHMchm81iWVYcs+N1KjqdDo1Gg1KpxL0vQrZ+fPu584In9lBytRSgewjT7/lfFqsUrpa5estlYWGBmZmZYU0GYno2DMPDgnzj7sexFD9X7j6A+d/zFK0nr/LPdp65xe/wPC+2/FOzZ2VxC8dxRko4Tg1Zp9DAtu2zQTZ9fv/skM2c66Ds0fLmU0M2O+OjlDpIKWMi1puapmEYBul0mtz15djKB0Xm2kMKF9KknBSGHr9QixVnfd+n3W6zvb1NuVxmb2+vZzyKIgJfsHI/x/qdwVqnhZu/MX+jipP3MWVvNZDJZJibm2NqegpLWrG6FBAzzmqahpSSfD6PaZq4rtsz3s2glP2I9TuDyVy4vcHl1y9hWUczKMuySKfTKEuNVALGIiuEwDAMhBCYpnmkcd3tUtRqNbQUfT9vCAm5fOqweH/Wc91tM2qtG5usEAJN0zDNo820LlnLskD3eDYjOiLPBGlJbMdGKYVpDP9pZBCcmtP4ODAhO66YkB1XTMiOKyZkxxUTsuOKCdlxxYTsuGJCdlyR6J0Kx3G4+MkvrH/z4tttF27+SiYzha7rI13q6odE7ht3RTabTarVKq1W64XzbdtmanoKx3EOrhuIZBbciV6uftn4FyZTllUzR6hgAAAAAElFTkSuQmCC"

/***/ }),

/***/ 16:
/***/ (function(module, exports) {

	module.exports = "data:image/png;base64,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"

/***/ }),

/***/ 66:
/***/ (function(module, exports) {

	module.exports = "data:image/svg+xml;base64,PD94bWwgdmVyc2lvbj0iMS4wIiBlbmNvZGluZz0idXRmLTgiPz4KPCEtLSBHZW5lcmF0b3I6IEFkb2JlIElsbHVzdHJhdG9yIDIyLjEuMCwgU1ZHIEV4cG9ydCBQbHVnLUluIC4gU1ZHIFZlcnNpb246IDYuMDAgQnVpbGQgMCkgIC0tPgo8c3ZnIHZlcnNpb249IjEuMSIgaWQ9IkxheWVyXzEiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyIgeG1sbnM6eGxpbms9Imh0dHA6Ly93d3cudzMub3JnLzE5OTkveGxpbmsiIHg9IjBweCIgeT0iMHB4IgoJIHZpZXdCb3g9IjAgMCA0NS45IDU4LjQiIHN0eWxlPSJlbmFibGUtYmFja2dyb3VuZDpuZXcgMCAwIDQ1LjkgNTguNDsiIHhtbDpzcGFjZT0icHJlc2VydmUiPgo8c3R5bGUgdHlwZT0idGV4dC9jc3MiPgoJLnN0MHtmaWxsLXJ1bGU6ZXZlbm9kZDtjbGlwLXJ1bGU6ZXZlbm9kZDtmaWxsOiNjZTJlNDg7fQo8L3N0eWxlPgo8cGF0aCBjbGFzcz0ic3QwIiBkPSJNNDEuNywxNi45bC01LjgsMmwwLTAuOWMwLTEuNy0yLjEtMi43LTMuNC0xLjZsLTQuMSw0LjdsMy0xMS40YzAuMi0xLjctMS44LTIuOS0zLjMtMS45bC0wLjgsMC41bC0xLjctNS44CgljLTAuNi0xLTItMS4yLTIuOC0wLjNsLTMsNS41bC0xLjUtMS4yYy0xLjYtMS4zLTMuOSwwLTMuNywyTDE2LjEsMjBsLTMuMS0zLjNjLTEuNC0xLjEtMy40LTAuMS0zLjQsMS43bDAsMC45bC01LjgtMS44CgljLTEuMi0wLjEtMi4xLDEtMS43LDIuMWwzLjEsNS41bC0xLjksMC42QzEuNCwyNi40LDEuMiwyOSwzLDI5LjlsOS4zLDQuNUwxMC44LDM4Yy0wLjUsMS4yLDAuNSwyLjUsMS44LDIuM2w5LTEuMwoJYzAuMSw1LjYsMC4zLDExLjMsMC43LDE2LjljMC4xLDEuMiwxLjksMS4xLDEuOCwwYy0wLjQtNS42LTAuNi0xMS4yLTAuNy0xNi45bDguOCwwLjljMS4zLDAuMSwyLjMtMS4yLDEuOC0yLjRsLTEuMi0yLjlMNDMsMjkuMwoJYzEuOC0wLjksMS41LTMuNi0wLjQtNC4ybC0xLjktMC41bDIuOS01LjZDNDMuOCwxNy44LDQyLjgsMTYuOCw0MS43LDE2Ljl6Ii8+Cjwvc3ZnPgo="

/***/ }),

/***/ 470:
/***/ (function(module, exports) {

	module.exports = "data:image/svg+xml;base64,PD94bWwgdmVyc2lvbj0iMS4wIiBlbmNvZGluZz0idXRmLTgiPz4KPCEtLSBHZW5lcmF0b3I6IEFkb2JlIElsbHVzdHJhdG9yIDIyLjEuMCwgU1ZHIEV4cG9ydCBQbHVnLUluIC4gU1ZHIFZlcnNpb246IDYuMDAgQnVpbGQgMCkgIC0tPgo8c3ZnIHZlcnNpb249IjEuMSIgaWQ9IkxheWVyXzEiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyIgeG1sbnM6eGxpbms9Imh0dHA6Ly93d3cudzMub3JnLzE5OTkveGxpbmsiIHg9IjBweCIgeT0iMHB4IgoJIHZpZXdCb3g9IjAgMCA0NS45IDU4LjQiIHN0eWxlPSJlbmFibGUtYmFja2dyb3VuZDpuZXcgMCAwIDQ1LjkgNTguNDsiIHhtbDpzcGFjZT0icHJlc2VydmUiPgo8c3R5bGUgdHlwZT0idGV4dC9jc3MiPgoJLnN0MHtmaWxsLXJ1bGU6ZXZlbm9kZDtjbGlwLXJ1bGU6ZXZlbm9kZDtmaWxsOiNmZmY7fQo8L3N0eWxlPgo8cGF0aCBjbGFzcz0ic3QwIiBkPSJNNDEuNywxNi45bC01LjgsMmwwLTAuOWMwLTEuNy0yLjEtMi43LTMuNC0xLjZsLTQuMSw0LjdsMy0xMS40YzAuMi0xLjctMS44LTIuOS0zLjMtMS45bC0wLjgsMC41bC0xLjctNS44CgljLTAuNi0xLTItMS4yLTIuOC0wLjNsLTMsNS41bC0xLjUtMS4yYy0xLjYtMS4zLTMuOSwwLTMuNywyTDE2LjEsMjBsLTMuMS0zLjNjLTEuNC0xLjEtMy40LTAuMS0zLjQsMS43bDAsMC45bC01LjgtMS44CgljLTEuMi0wLjEtMi4xLDEtMS43LDIuMWwzLjEsNS41bC0xLjksMC42QzEuNCwyNi40LDEuMiwyOSwzLDI5LjlsOS4zLDQuNUwxMC44LDM4Yy0wLjUsMS4yLDAuNSwyLjUsMS44LDIuM2w5LTEuMwoJYzAuMSw1LjYsMC4zLDExLjMsMC43LDE2LjljMC4xLDEuMiwxLjksMS4xLDEuOCwwYy0wLjQtNS42LTAuNi0xMS4yLTAuNy0xNi45bDguOCwwLjljMS4zLDAuMSwyLjMtMS4yLDEuOC0yLjRsLTEuMi0yLjlMNDMsMjkuMwoJYzEuOC0wLjksMS41LTMuNi0wLjQtNC4ybC0xLjktMC41bDIuOS01LjZDNDMuOCwxNy44LDQyLjgsMTYuOCw0MS43LDE2Ljl6Ii8+Cjwvc3ZnPgo="

/***/ }),

/***/ 17:
/***/ (function(module, exports) {

	module.exports = "data:image/png;base64,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"

/***/ }),

/***/ 319:
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),

/***/ 224:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(6);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactHelmet = __webpack_require__(429);
	
	var _reactHelmet2 = _interopRequireDefault(_reactHelmet);
	
	var _Header = __webpack_require__(223);
	
	var _Header2 = _interopRequireDefault(_Header);
	
	var _Footer = __webpack_require__(92);
	
	var _Footer2 = _interopRequireDefault(_Footer);
	
	__webpack_require__(319);
	
	var _davos_favicon = __webpack_require__(467);
	
	var _davos_favicon2 = _interopRequireDefault(_davos_favicon);
	
	var _davos_share = __webpack_require__(468);
	
	var _davos_share2 = _interopRequireDefault(_davos_share);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var TemplateWrapper = function TemplateWrapper(_ref) {
	  var children = _ref.children;
	  return _react2.default.createElement(
	    "div",
	    { className: "flex flex-col font-sans min-h-screen text-grey-darkest overflow-x-hidden" },
	    _react2.default.createElement(_reactHelmet2.default, {
	      title: "Davos | Give Meaning",
	      meta: [{ name: 'description', content: 'Davos is an easy-to-use online fundraising platform created for small and medium sized charities in Canada.' }, { name: 'keywords', content: 'Canada, Davos, Fundraising, Non-Profits, NPO, Charities, Online Fundraising' }, { property: "og:url", content: "https://davos.gives" }, { property: "og:title", content: "Davos - Give Meaning" }, { property: "og:description", content: "Davos is an easy-to-use online fundraising platform created for small and medium sized charities in Canada." }, { property: "og:image", content: "" + _davos_share2.default }],
	      link: [{ rel: 'shortcut icon', type: 'image/png', href: "" + _davos_favicon2.default }]
	    }),
	    _react2.default.createElement(_Header2.default, null),
	    _react2.default.createElement(
	      "div",
	      { className: "" },
	      children()
	    )
	  );
	};
	
	TemplateWrapper.propTypes = {
	  children: _propTypes2.default.func
	};
	
	exports.default = TemplateWrapper;
	module.exports = exports["default"];

/***/ })

});


// WEBPACK FOOTER //
// component---src-layouts-index-js-f52c428c989af3d22bb7.js